export const deliveryConfig = {
  BaseUrl: "/delivery",
  LoginRedirect: "/app",
  TokenKey: "delivery-token",
  AuthorTokenKey: "author-token",
}
